import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG } from '../../config/environment.token';
import { Environment } from '../../../../environments/environment.model';
import {
  ApiResponse,
  PaginatedApiResponse,
} from '../../../shared/types/api.type';
import {
  UnreadCountResponse,
  UserNotification,
} from './types/user-notification.type';

@Injectable({ providedIn: 'root' })
export class UserNotificationsService {
  private readonly http = inject(HttpClient);
  private readonly appConfig = inject(APP_CONFIG) as Environment;
  private readonly baseUrl = `${this.appConfig.apiUrl}/user-notifications`;

  list(
    page: number,
    limit: number,
    unreadOnly = false,
  ): Observable<PaginatedApiResponse<UserNotification>> {
    const params = new HttpParams()
      .set('page', String(page))
      .set('limit', String(limit))
      .set('unreadOnly', String(unreadOnly));
    return this.http.get<PaginatedApiResponse<UserNotification>>(this.baseUrl, {
      params,
    });
  }

  unreadCount(): Observable<ApiResponse<UnreadCountResponse>> {
    return this.http.get<ApiResponse<UnreadCountResponse>>(
      `${this.baseUrl}/unread-count`,
    );
  }

  markAsRead(id: number): Observable<ApiResponse<void>> {
    return this.http.patch<ApiResponse<void>>(
      `${this.baseUrl}/${id}/read`,
      {},
    );
  }

  markAllAsRead(): Observable<ApiResponse<void>> {
    return this.http.patch<ApiResponse<void>>(`${this.baseUrl}/read-all`, {});
  }
}
